// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	FieldValueNameDatePicker: 'field-value-name-date-picker',
	FieldValueNameDropdown: 'field-value-name-dropdown',
	SearchTerm: 'search-term',
	RequisitionTitle: 'requisition-title',
	FieldValueName: 'field-value-name',
	FieldValueName1: 'field-value-name-1',
	TitleFilterRadioGroup: 'title-filter-radio-group',
	FieldValueNameTextArea: 'field-value-name-text-area',
	CloseModalButton: 'close-modal-button',
	RequisitionSelectButton: 'requisition-select-button',
	//	MyHookName: 'myHookIdentifier',
} as const;
/*
NOTE: The above hooks have been auto generated, all naming is a best guess approach.
Please review them, edit where necessary and delete this comment to indicate that the names are correct.
*/
